import React from "react"
// MUI
import {Button, Grid, TextField, Typography} from "@mui/material"
// style
import {style} from "./style"

export default function QRCodeEvent(props: any) {
    return (
        <Grid item md={12} sx={style.mainWrapper}>
            <Typography sx={style.title}>{props.fieldDisplay.title}</Typography>
            <Typography sx={style.locationTypo}>{props.fieldDisplay.location}</Typography>
            <TextField
                label="Time location"
                type="text"
                value={props.fieldDisplay.time_zone}
                sx={style.textTimeAndDate}
                disabled
            />
            <TextField
                label="Event Start"
                type="datetime-local"
                value={props.fieldDisplay.start_date}
                defaultValue="2017-05-24T10:30"
                sx={style.textTimeAndDate}
                disabled
            />
            <TextField
                label="Event End"
                type="datetime-local"
                value={props.fieldDisplay.end_date}
                defaultValue="2017-05-24T10:33"
                sx={style.textTimeAndDate}
                disabled
            />
            <Button variant={'contained'}
                    sx={style.button}
                    onClick={props.DownloadIcsFile}>Add to calendar</Button>
        </Grid>
    );
}
